import {
  GRAFTCODE_ONBOARDING_GOAL,
  GRAFTCODE_ONBOARDING_PHASE,
  GRAFTCODE_ONBOARDING_SETUP_MODE,
  GRAFTCODE_ONBOARDING_WIZARD_STEP,
} from '../graftcode-onboarding.const'
import { GRAFTCODE_ONBOARDING_GUIDE_OS } from '../lib/graftcode-onboarding-guide-os.const'

import type { GraftcodeOnboardingStoreState } from './graftcode-onboarding.type'

export const graftcodeOnboardingInitialState: GraftcodeOnboardingStoreState = {
  phase: GRAFTCODE_ONBOARDING_PHASE.idle,
  wizardStep: GRAFTCODE_ONBOARDING_WIZARD_STEP.goal,
  wizardCompleted: false,
  goalId: GRAFTCODE_ONBOARDING_GOAL.ai,
  scenarioId: null,
  selectedStackId: 'react',
  setupMode: GRAFTCODE_ONBOARDING_SETUP_MODE.agent,
  activeStepIndex: 0,
  tutorialCompleted: false,
  tutorialVideoHidden: false,
  tutorialVideoPlaying: false,
  completedScenarioIds: [],
  primaryScenarioId: null,
  lastCompletedStackId: null,
  completedStacksByScenario: {},
  guideOs: GRAFTCODE_ONBOARDING_GUIDE_OS.macos,
  guideOsManual: false,
  hydrated: false,
}
